import Morse1 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_1.png';
import Morse2 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_2.png';
import Morse3 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_3.png';
import Morse4 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_4.png';
import Morse5 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_5.png';
import Morse6 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_6.png';
import Morse7 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_7.png';
import Morse8 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_8.png';
import Morse9 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_9.png';
import Morse10 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_10.png';
import Morse11 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_11.png';
import Morse12 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_12.png';
import Morse13 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_13.png';
import Morse14 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_14.png';
import Morse15 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_15.png';
import Morse16 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_16.png';
import Morse17 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_17.png';
import Morse18 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_18.png';
import Morse19 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_19.png';
import Morse20 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_20.png';
import Morse21 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_21.png';
import Morse22 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_22.png';
import Morse23 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_23.png';
import Morse24 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_24.png';
import Morse25 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_25.png';
import Morse26 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_26.png';
import Morse27 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_27.png';
import Morse28 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_28.png';
import Morse29 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_29.png';
import Morse30 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_30.png';
import Morse31 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_31.png';
import Morse32 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_32.png';
import Morse33 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_33.png';
import Morse34 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_34.png';
import Morse35 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_35.png';
import Morse36 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_36.png';
import Morse37 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_37.png';
import Morse38 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_38.png';
import Morse39 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_39.png';
import Morse40 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_40.png';
import Morse41 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_41.png';
import Morse42 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_42.png';
import Morse43 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_43.png';
import Morse44 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_44.png';
import Morse45 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_45.png';
import Morse46 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_46.png';
import Morse47 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_47.png';
import Morse48 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_48.png';
import Morse49 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_49.png';
import Morse50 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_50.png';
import Morse51 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_51.png';
import Morse52 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_52.png';
import Morse53 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_53.png';
import Morse54 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_54.png';
import Morse55 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_55.png';
import Morse56 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_56.png';
import Morse57 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_57.png';
import Morse58 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_58.png';
import Morse59 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_59.png';
import Morse60 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_60.png';
import Morse61 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_61.png';
import Morse62 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_62.png';
import Morse63 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_63.png';
import Morse64 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_64.png';
import Morse65 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_65.png';
import Morse66 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_66.png';
import Morse67 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_67.png';
import Morse68 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_68.png';
import Morse69 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_69.png';
import Morse70 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_70.png';
import Morse71 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_71.png';
import Morse72 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_72.png';
import Morse73 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_73.png';
import Morse74 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_74.png';
import Morse75 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_75.png';
import Morse76 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_76.png';
import Morse77 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_77.png';
import Morse78 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_78.png';
import Morse79 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_79.png';
import Morse80 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_80.png';
import Morse81 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_81.png';
import Morse82 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_82.png';
import Morse83 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_83.png';
import Morse84 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_84.png';
import Morse85 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_85.png';
import Morse86 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_86.png';
import Morse87 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_87.png';
import Morse88 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_88.png';
import Morse89 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_89.png';
import Morse90 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_90.png';
import Morse91 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_91.png';
import Morse92 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_92.png';
import Morse93 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_93.png';
import Morse94 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_94.png';
import Morse95 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_95.png';
import Morse96 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_96.png';
import Morse97 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_97.png';
import Morse98 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_98.png';
import Morse99 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_99.png';
import Morse100 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_100.png';
import Morse101 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_101.png';
import Morse102 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_102.png';
import Morse103 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_103.png';
import Morse104 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_104.png';
import Morse105 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_105.png';
import Morse106 from 'assets/images/Cockpit/Decryption/Morse/Individual/Individual_106.png';
import MorseAnimation from 'assets/images/Cockpit/Decryption/Morse/Morse-Animation.gif';
import MorseOpened from 'assets/images/Cockpit/Decryption/Morse/Morse.png';
import PaperAnimation from 'assets/images/Cockpit/Decryption/Paper-Animation.gif';
import PaperOpened from 'assets/images/Cockpit/Decryption/Paper-Opened.gif';
import MorseOpeningSound from 'assets/sounds/MorseOpening.mp3';
import PaperOpeningSound from 'assets/sounds/PaperOpening.mp3';

import { useAppDispatch, useAppSelector } from 'hooks';

import { modeActions, selectMode } from 'store/mode';

import DecryptionPaperXButton from 'components/Space/DecrpytionPaper/XButton';

import {
  RollupAnimationState,
  rollupAnimationStateFlow,
  rollupAnimationStateInterval,
} from 'util/animation';
import { morseCodeIndex } from 'util/morse';

import { CSSProperties, useEffect, useRef, useState } from 'react';

function DecryptionPaperOpened(props: CSSProperties) {
  const paperOpenAudioRef = useRef(new Audio(PaperOpeningSound));
  const morseOpenAudioRef = useRef(new Audio(MorseOpeningSound));

  const mode = useAppSelector(selectMode);
  const dispatch = useAppDispatch();

  const IndividualCode = [
    Morse1,
    Morse2,
    Morse3,
    Morse4,
    Morse5,
    Morse6,
    Morse7,
    Morse8,
    Morse9,
    Morse10,
    Morse11,
    Morse12,
    Morse13,
    Morse14,
    Morse15,
    Morse16,
    Morse17,
    Morse18,
    Morse19,
    Morse20,
    Morse21,
    Morse22,
    Morse23,
    Morse24,
    Morse25,
    Morse26,
    Morse27,
    Morse28,
    Morse29,
    Morse30,
    Morse31,
    Morse32,
    Morse33,
    Morse34,
    Morse35,
    Morse36,
    Morse37,
    Morse38,
    Morse39,
    Morse40,
    Morse41,
    Morse42,
    Morse43,
    Morse44,
    Morse45,
    Morse46,
    Morse47,
    Morse48,
    Morse49,
    Morse50,
    Morse51,
    Morse52,
    Morse53,
    Morse54,
    Morse55,
    Morse56,
    Morse57,
    Morse58,
    Morse59,
    Morse60,
    Morse61,
    Morse62,
    Morse63,
    Morse64,
    Morse65,
    Morse66,
    Morse67,
    Morse68,
    Morse69,
    Morse70,
    Morse71,
    Morse72,
    Morse73,
    Morse74,
    Morse75,
    Morse76,
    Morse77,
    Morse78,
    Morse79,
    Morse80,
    Morse81,
    Morse82,
    Morse83,
    Morse84,
    Morse85,
    Morse86,
    Morse87,
    Morse88,
    Morse89,
    Morse90,
    Morse91,
    Morse92,
    Morse93,
    Morse94,
    Morse95,
    Morse96,
    Morse97,
    Morse98,
    Morse99,
    Morse100,
    Morse101,
    Morse102,
    Morse103,
    Morse104,
    Morse105,
    Morse106,
  ];

  /** Open Animation */

  const [currentAnimation, setCurrentAnimation] = useState(
    RollupAnimationState.Completed,
  );

  const animationFirst = () => {
    setCurrentAnimation(rollupAnimationStateFlow[currentAnimation]);
    paperOpenAudioRef.current.currentTime = 0;
    paperOpenAudioRef.current.play();
  };
  const animationSecond = () => {
    setCurrentAnimation(rollupAnimationStateFlow[currentAnimation]);
    morseOpenAudioRef.current.currentTime = 0;
    morseOpenAudioRef.current.play();
  };
  const animationLast = () => {
    setCurrentAnimation(rollupAnimationStateFlow[currentAnimation]);
    dispatch(modeActions.setOpeningIsStart());
  };
  const rollupAnimationStateAction: {
    [key in RollupAnimationState]: () => void;
  } = {
    [RollupAnimationState.Completed]: animationFirst,
    [RollupAnimationState.Paper]: animationSecond,
    [RollupAnimationState.Morse]: animationLast,
  };

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    if (mode.decryptingState.isStart) {
      intervalId = setInterval(
        rollupAnimationStateAction[currentAnimation],
        rollupAnimationStateInterval[currentAnimation],
      );
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [mode.decryptingState.isStart, currentAnimation]);

  const renderImages = (isStart: boolean, animation: RollupAnimationState) => {
    if (isStart) {
      switch (animation) {
        case RollupAnimationState.Paper:
          return (
            <img
              draggable='false'
              src={`${PaperAnimation}?${mode.decryptingState.imageKey}`}
              alt='paper opening'
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
              }}
            />
          );
        case RollupAnimationState.Morse:
          return (
            <>
              <img
                draggable='false'
                src={PaperOpened}
                alt='paper opened'
                style={{
                  width: '100%',
                  objectFit: 'cover',
                  position: 'absolute',
                }}
              />
              <img
                draggable='false'
                src={`${MorseAnimation}?${mode.decryptingState.imageKey}`}
                alt='morse open animation'
                style={{
                  width: '100%',
                  objectFit: 'cover',
                  position: 'absolute',
                  opacity: 0.2,
                }}
              />
              <DecryptionPaperXButton
                width='4%'
                left='84%'
                height='8%'
                top='18%'
                position='absolute'
                display='flex'
              />
            </>
          );
        case RollupAnimationState.Completed:
        default:
          return null;
      }
    }
    return (
      <>
        <img
          draggable='false'
          src={PaperOpened}
          alt='paper opened'
          style={{ width: '100%', objectFit: 'cover', position: 'absolute' }}
        />
        <img
          draggable='false'
          src={MorseOpened}
          alt='morse opened'
          style={{
            width: '100%',
            objectFit: 'cover',
            position: 'absolute',
            opacity: 0.2,
          }}
        />
        <img
          draggable='false'
          src={
            mode.decryptingState.code
              ? IndividualCode[morseCodeIndex[mode.decryptingState.code]]
              : ''
          }
          alt='paper opened'
          style={{
            width: '100%',
            objectFit: 'cover',
            position: 'absolute',
            display: `${mode.decryptingState.code ? 'flex' : 'none'}`,
          }}
        />
        <DecryptionPaperXButton
          width='4%'
          left='84%'
          height='8%'
          top='18%'
          position='absolute'
          display='flex'
        />
      </>
    );
  };

  return (
    <div id='Paper Opened' draggable='false' style={{ ...props }}>
      {renderImages(mode.decryptingState.isStart, currentAnimation)}
    </div>
  );
}

export default DecryptionPaperOpened;
